import { ref, watch } from 'vue'

export const useAnimatedNumber = (
  target: () => number,
  duration = 600,
  easing: (t: number) => number = (t) => 1 - Math.pow(1 - t, 5),
) => {
  const animated = ref(target())

  watch(
    target,
    (newValue, oldValue) => {
      const start = performance.now()
      const from = oldValue ?? 0
      const to = newValue ?? 0

      function tick(now: number) {
        const progress = Math.min((now - start) / duration, 1)
        const eased = easing(progress)
        animated.value = from + (to - from) * eased
        if (progress < 1) requestAnimationFrame(tick)
      }

      requestAnimationFrame(tick)
    },
    { immediate: true },
  )

  return animated
}
